// import type { GetAccountBonusesResponse } from '@patrianna/shared-patrianna-types/store/AccountBonusesModule'
import type { GetAccountBonusesRequest } from '@patrianna/shared-patrianna-types/websocket/requests'

import type { TypedThunk } from 'src/store/types'
import { receivedBonuses, setBonusesLoaded, setBonusesLoading } from 'store/modules/bonusesFlow/actions'
import type { GetAccountBonusesResponseExt } from 'store/modules/bonusesFlow/slice' // TODO: temp
import { saveBrandConfig } from 'store/modules/brandConfig/actions'
import { isSevenDaysRewardsEnabledSelector } from 'store/modules/brandConfig/selectors'
import { fetchBrandConfig } from 'utils/fetchBrandConfig'

const getAccountBonusesRequest =
  (): TypedThunk =>
  async (dispatch, getState, { api, errorHandler }) => {
    const data: GetAccountBonusesRequest = {
      type: 'GetAccountBonusesRequest',
    }

    let isSevenDaysRewardsEnabled = isSevenDaysRewardsEnabledSelector(getState())

    dispatch(setBonusesLoaded(false))
    dispatch(setBonusesLoading(true))

    // If brand config is not yet loaded (e.g., slow network/VPN), fetch and persist it
    if (typeof isSevenDaysRewardsEnabled === 'undefined' || isSevenDaysRewardsEnabled === null) {
      try {
        const brandConfig = await fetchBrandConfig()
        if (brandConfig) {
          dispatch(saveBrandConfig(brandConfig))
          isSevenDaysRewardsEnabled = brandConfig?.dailyRewardDialog?.sevenDaysRewardsEnabled as boolean | undefined
        }
      } catch {
        // ignore, will fall back to falsy payload
      }
    }

    const payload = isSevenDaysRewardsEnabled
      ? {
          // FYI: paginatedDailyBonuses option is required if you want to receive bonuses for 7 days including the previous ones
          paginatedDailyBonuses: true,
          dailyBonusesVersion: '4w1w',
        }
      : {}

    try {
      const body = await api.getAccountBonuses(payload)
      dispatch(receivedBonuses({ body: body as unknown as GetAccountBonusesResponseExt }))
    } catch (err) {
      dispatch(errorHandler(err, data))
    } finally {
      dispatch(setBonusesLoading(false))
      dispatch(setBonusesLoaded(true))
    }
  }

export default getAccountBonusesRequest
